import { isSport } from "../../../common";

// See play-style-adjustments in bbgm-rosters.
// This used to include the threePointers setting, but since now that is in Game Simulation rather than Tendencies, it's not here anymore. Same with other various settings that change over time in real players leagues.
const gameSimPresets = isSport("basketball")
	? {
			2020: {
				pace: 100.2,
				threePointTendencyFactor: 1,
				threePointAccuracyFactor: 1,
				twoPointAccuracyFactor: 1,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 1.09,
				turnoverFactor: 1,
				orbFactor: 1,
			},
			2019: {
				pace: 100,
				threePointTendencyFactor: 0.946,
				threePointAccuracyFactor: 0.994,
				twoPointAccuracyFactor: 1,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 1.1,
				turnoverFactor: 1,
				orbFactor: 1,
			},
			2018: {
				pace: 97.3,
				threePointTendencyFactor: 0.881,
				threePointAccuracyFactor: 1.014,
				twoPointAccuracyFactor: 1,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 1.14,
				turnoverFactor: 1,
				orbFactor: 1,
			},
			2017: {
				pace: 96.4,
				threePointTendencyFactor: 0.827,
				threePointAccuracyFactor: 1.003,
				twoPointAccuracyFactor: 1,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 1.16,
				turnoverFactor: 1,
				orbFactor: 1,
			},
			2016: {
				pace: 95.8,
				threePointTendencyFactor: 0.744,
				threePointAccuracyFactor: 0.992,
				twoPointAccuracyFactor: 1,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.16,
				turnoverFactor: 1.01,
				orbFactor: 1,
			},
			2015: {
				pace: 93.9,
				threePointTendencyFactor: 0.705,
				threePointAccuracyFactor: 0.98,
				twoPointAccuracyFactor: 1,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.15,
				turnoverFactor: 1.02,
				orbFactor: 1.024375,
			},
			2014: {
				pace: 93.9,
				threePointTendencyFactor: 0.676,
				threePointAccuracyFactor: 1.008,
				twoPointAccuracyFactor: 1,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.13,
				turnoverFactor: 1.03,
				orbFactor: 1.024375,
			},
			2013: {
				pace: 92,
				threePointTendencyFactor: 0.64,
				threePointAccuracyFactor: 1.006,
				twoPointAccuracyFactor: 0.991,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.15,
				turnoverFactor: 1.04,
				orbFactor: 1.041625,
			},
			2012: {
				pace: 91.3,
				threePointTendencyFactor: 0.595,
				threePointAccuracyFactor: 0.978,
				twoPointAccuracyFactor: 0.978,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.14,
				turnoverFactor: 1.04,
				orbFactor: 1.0555,
			},
			2011: {
				pace: 92.1,
				threePointTendencyFactor: 0.577,
				threePointAccuracyFactor: 1.003,
				twoPointAccuracyFactor: 0.999,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.08,
				turnoverFactor: 1.03,
				orbFactor: 1.034875,
			},
			2010: {
				pace: 92.7,
				threePointTendencyFactor: 0.577,
				threePointAccuracyFactor: 0.994,
				twoPointAccuracyFactor: 1.009,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.09,
				turnoverFactor: 1.02,
				orbFactor: 1.031125,
			},
			2009: {
				pace: 91.7,
				threePointTendencyFactor: 0.583,
				threePointAccuracyFactor: 1.028,
				twoPointAccuracyFactor: 0.995,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.1,
				turnoverFactor: 1.02,
				orbFactor: 1.041625,
			},
			2008: {
				pace: 92.4,
				threePointTendencyFactor: 0.58,
				threePointAccuracyFactor: 1.014,
				twoPointAccuracyFactor: 0.993,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.1,
				turnoverFactor: 1.02,
				orbFactor: 1.041625,
			},
			2007: {
				pace: 91.9,
				threePointTendencyFactor: 0.545,
				threePointAccuracyFactor: 1.003,
				twoPointAccuracyFactor: 0.995,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.02,
				turnoverFactor: 1.06,
				orbFactor: 1.041625,
			},
			2006: {
				pace: 90.5,
				threePointTendencyFactor: 0.521,
				threePointAccuracyFactor: 1.003,
				twoPointAccuracyFactor: 0.98,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.09,
				turnoverFactor: 1.04,
				orbFactor: 1.04875,
			},
			2005: {
				pace: 90.9,
				threePointTendencyFactor: 0.512,
				threePointAccuracyFactor: 0.997,
				twoPointAccuracyFactor: 0.964,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.14,
				turnoverFactor: 1.04,
				orbFactor: 1.079875,
			},
			2004: {
				pace: 90.1,
				threePointTendencyFactor: 0.488,
				threePointAccuracyFactor: 0.972,
				twoPointAccuracyFactor: 0.943,
				ftAccuracyFactor: 1,
				blockFactor: 1.2,
				stealFactor: 1.16,
				turnoverFactor: 1.07,
				orbFactor: 1.086625,
			},
			2003: {
				pace: 91,
				threePointTendencyFactor: 0.476,
				threePointAccuracyFactor: 0.978,
				twoPointAccuracyFactor: 0.949,
				ftAccuracyFactor: 1,
				blockFactor: 1.2,
				stealFactor: 1.16,
				turnoverFactor: 1.06,
				orbFactor: 1.079875,
			},
			2002: {
				pace: 90.7,
				threePointTendencyFactor: 0.479,
				threePointAccuracyFactor: 0.992,
				twoPointAccuracyFactor: 0.954,
				ftAccuracyFactor: 1,
				blockFactor: 1.2,
				stealFactor: 1.17,
				turnoverFactor: 1.04,
				orbFactor: 1.090375,
			},
			2001: {
				pace: 91.3,
				threePointTendencyFactor: 0.443,
				threePointAccuracyFactor: 0.992,
				twoPointAccuracyFactor: 0.946,
				ftAccuracyFactor: 1,
				blockFactor: 1.2,
				stealFactor: 1.15,
				turnoverFactor: 1.06,
				orbFactor: 1.0765,
			},
			2000: {
				pace: 93.1,
				threePointTendencyFactor: 0.435,
				threePointAccuracyFactor: 0.989,
				twoPointAccuracyFactor: 0.96,
				ftAccuracyFactor: 1,
				blockFactor: 1.2,
				stealFactor: 1.17,
				turnoverFactor: 1.07,
				orbFactor: 1.086625,
			},
			1999: {
				pace: 88.9,
				threePointTendencyFactor: 0.438,
				threePointAccuracyFactor: 0.95,
				twoPointAccuracyFactor: 0.937,
				ftAccuracyFactor: 1,
				blockFactor: 1.2,
				stealFactor: 1.17,
				turnoverFactor: 1.09,
				orbFactor: 1.111,
			},
			1998: {
				pace: 90.3,
				threePointTendencyFactor: 0.417,
				threePointAccuracyFactor: 0.969,
				twoPointAccuracyFactor: 0.965,
				ftAccuracyFactor: 1,
				blockFactor: 1.2,
				stealFactor: 1.23,
				turnoverFactor: 1.09,
				orbFactor: 1.1215,
			},
			1997: {
				pace: 90.1,
				threePointTendencyFactor: 0.551,
				threePointAccuracyFactor: 1.008,
				twoPointAccuracyFactor: 0.985,
				ftAccuracyFactor: 1,
				blockFactor: 1.2,
				stealFactor: 1.21,
				turnoverFactor: 1.09,
				orbFactor: 1.107625,
			},
			1996: {
				pace: 91.8,
				threePointTendencyFactor: 0.518,
				threePointAccuracyFactor: 1.028,
				twoPointAccuracyFactor: 0.996,
				ftAccuracyFactor: 1,
				blockFactor: 1.2,
				stealFactor: 1.15,
				turnoverFactor: 1.09,
				orbFactor: 1.100875,
			},
			1995: {
				pace: 92.9,
				threePointTendencyFactor: 0.485,
				threePointAccuracyFactor: 1.006,
				twoPointAccuracyFactor: 1.007,
				ftAccuracyFactor: 1,
				blockFactor: 1.2,
				stealFactor: 1.18,
				turnoverFactor: 1.09,
				orbFactor: 1.107625,
			},
			1994: {
				pace: 95.1,
				threePointTendencyFactor: 0.31,
				threePointAccuracyFactor: 0.933,
				twoPointAccuracyFactor: 0.991,
				ftAccuracyFactor: 1,
				blockFactor: 1.2,
				stealFactor: 1.25,
				turnoverFactor: 1.07,
				orbFactor: 1.128625,
			},
			1993: {
				pace: 96.8,
				threePointTendencyFactor: 0.274,
				threePointAccuracyFactor: 0.941,
				twoPointAccuracyFactor: 1.003,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.23,
				turnoverFactor: 1.06,
				orbFactor: 1.118125,
			},
			1992: {
				pace: 96.6,
				threePointTendencyFactor: 0.232,
				threePointAccuracyFactor: 0.927,
				twoPointAccuracyFactor: 0.997,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.21,
				turnoverFactor: 1.06,
				orbFactor: 1.135375,
			},
			1991: {
				pace: 97.8,
				threePointTendencyFactor: 0.214,
				threePointAccuracyFactor: 0.896,
				twoPointAccuracyFactor: 1.001,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.2,
				turnoverFactor: 1.06,
				orbFactor: 1.118125,
			},
			1990: {
				pace: 98.3,
				threePointTendencyFactor: 0.199,
				threePointAccuracyFactor: 0.927,
				twoPointAccuracyFactor: 1.001,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.16,
				turnoverFactor: 1.06,
				orbFactor: 1.111,
			},
			1989: {
				pace: 100.6,
				threePointTendencyFactor: 0.193,
				threePointAccuracyFactor: 0.905,
				twoPointAccuracyFactor: 1.004,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.2,
				turnoverFactor: 1.09,
				orbFactor: 1.1215,
			},
			1988: {
				pace: 99.6,
				threePointTendencyFactor: 0.149,
				threePointAccuracyFactor: 0.885,
				twoPointAccuracyFactor: 1.005,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.12,
				turnoverFactor: 1.07,
				orbFactor: 1.118125,
			},
			1987: {
				pace: 100.8,
				threePointTendencyFactor: 0.14,
				threePointAccuracyFactor: 0.843,
				twoPointAccuracyFactor: 1.006,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.08,
				turnoverFactor: 1.07,
				orbFactor: 1.128625,
			},
			1986: {
				pace: 102.1,
				threePointTendencyFactor: 0.095,
				threePointAccuracyFactor: 0.79,
				twoPointAccuracyFactor: 1.016,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.06,
				turnoverFactor: 1.1,
				orbFactor: 1.10425,
			},
			1985: {
				pace: 102.1,
				threePointTendencyFactor: 0.092,
				threePointAccuracyFactor: 0.79,
				twoPointAccuracyFactor: 1.023,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.03,
				turnoverFactor: 1.1,
				orbFactor: 1.107625,
			},
			1984: {
				pace: 101.4,
				threePointTendencyFactor: 0.068,
				threePointAccuracyFactor: 0.7,
				twoPointAccuracyFactor: 1.023,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.03,
				turnoverFactor: 1.1,
				orbFactor: 1.107625,
			},
			1983: {
				pace: 103.1,
				threePointTendencyFactor: 0.065,
				threePointAccuracyFactor: 0.667,
				twoPointAccuracyFactor: 1.009,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.01,
				turnoverFactor: 1.13,
				orbFactor: 1.1215,
			},
			1982: {
				pace: 100.9,
				threePointTendencyFactor: 0.065,
				threePointAccuracyFactor: 0.734,
				twoPointAccuracyFactor: 1.02,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1,
				turnoverFactor: 1.1,
				orbFactor: 1.11475,
			},
			1981: {
				pace: 101.8,
				threePointTendencyFactor: 0.06,
				threePointAccuracyFactor: 0.686,
				twoPointAccuracyFactor: 1.008,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.05,
				turnoverFactor: 1.13,
				orbFactor: 1.118125,
			},
			1980: {
				pace: 103.1,
				threePointTendencyFactor: 0.08,
				threePointAccuracyFactor: 0.784,
				twoPointAccuracyFactor: 1,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1.08,
				turnoverFactor: 1.13,
				orbFactor: 1.128625,
			},
			1979: {
				pace: 105.8,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.99575,
				ftAccuracyFactor: 1,
				blockFactor: 1.1,
				stealFactor: 1,
				turnoverFactor: 1.14,
				orbFactor: 1.111,
			},
			1978: {
				pace: 106.7,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.9762,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 1.07,
				turnoverFactor: 1.14,
				orbFactor: 1.107625,
			},
			1977: {
				pace: 106.5,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.9694,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 1.03,
				turnoverFactor: 1.16,
				orbFactor: 1.111,
			},
			1976: {
				pace: 105.5,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.9575,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.98,
				turnoverFactor: 1.14,
				orbFactor: 1.09375,
			},
			1975: {
				pace: 104.5,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.9558,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.94,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1974: {
				pace: 107.8,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.95835,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.097125,
			},
			1973: {
				pace: 110.385,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.9541,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1972: {
				pace: 109.785,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.9507,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1971: {
				pace: 112.988,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.9507,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1970: {
				pace: 114.811,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.96005,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1969: {
				pace: 114.571,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.9439,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1968: {
				pace: 117.058,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.95325,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1967: {
				pace: 119.602,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.9439,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1966: {
				pace: 118.921,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.92945,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1965: {
				pace: 115.617,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.91755,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1964: {
				pace: 114.689,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.92945,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1963: {
				pace: 117.316,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.9439,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1962: {
				pace: 125.168,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.9269,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1961: {
				pace: 127.219,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.9065,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1960: {
				pace: 126.113,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.898,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1959: {
				pace: 118.68,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.8725,
				ftAccuracyFactor: 1,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1958: {
				pace: 118.564,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.8521,
				ftAccuracyFactor: 0.99,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1957: {
				pace: 109.736,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.84615,
				ftAccuracyFactor: 0.99,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1956: {
				pace: 106.17,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.85805,
				ftAccuracyFactor: 0.99,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1955: {
				pace: 101,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.8455,
				ftAccuracyFactor: 0.98,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1954: {
				pace: 93,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.8333,
				ftAccuracyFactor: 0.97,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1953: {
				pace: 95,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.83,
				ftAccuracyFactor: 0.97,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1952: {
				pace: 97,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.8,
				twoPointAccuracyFactor: 0.8232,
				ftAccuracyFactor: 0.96,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1951: {
				pace: 99,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.7,
				twoPointAccuracyFactor: 0.81,
				ftAccuracyFactor: 0.96,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1950: {
				pace: 99,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.7,
				twoPointAccuracyFactor: 0.79,
				ftAccuracyFactor: 0.95,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1949: {
				pace: 104,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.7,
				twoPointAccuracyFactor: 0.77,
				ftAccuracyFactor: 0.94,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1948: {
				pace: 108,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.6,
				twoPointAccuracyFactor: 0.71,
				ftAccuracyFactor: 0.9,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
			1947: {
				pace: 104,
				threePointTendencyFactor: 0.025,
				threePointAccuracyFactor: 0.6,
				twoPointAccuracyFactor: 0.7,
				ftAccuracyFactor: 0.87,
				blockFactor: 1,
				stealFactor: 0.9,
				turnoverFactor: 1.15,
				orbFactor: 1.09375,
			},
		}
	: undefined;

export default gameSimPresets;
